import { Icon, type IconProps } from "@chakra-ui/react";
import React from "react";

export function SquareIcon(props: IconProps) {
  return (
    <Icon viewBox="0 0 18 18" {...props}>
      <rect width="18" height="18" fill="currentColor" />
    </Icon>
  );
}
